import { render } from "./MinSidebar.vue?vue&type=template&id=9c329de8"
import script from "./MinSidebar.vue?vue&type=script&lang=js"
export * from "./MinSidebar.vue?vue&type=script&lang=js"

import "./MinSidebar.vue?vue&type=style&index=0&id=9c329de8&lang=css"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__